import React from 'react';
import { Svg, SvgProps } from '@kizi/core-components';

export const LogoInsurance = (props: SvgProps) => {
  return (
    <Svg
      width="auto"
      height="32px"
      viewBox="0 0 78 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M8.99045 32C8.99045 32 8.1493 23.1116 23.0719 23.1116C37.2599 23.1116 44.8942 30.3236 63.7933 28.4442C81.6718 26.6668 91.1468 0 38.9868 0C-12.2253 0 -2.03957 24.8883 8.99045 32Z"
        fill="#3E70B7"
      />
      <path
        d="M30.375 10.5718H31.7479V10.0559H30.3245C29.9361 10.0559 29.6917 9.83558 29.6917 9.34541V8.33932H31.547V7.81688H29.6917V6.37115H31.7479V5.85571H29.103V9.29488C29.1031 10.1752 29.5414 10.5718 30.375 10.5718Z"
        fill="white"
      />
      <path
        d="M33.8111 10.1325C33.2723 10.1325 32.8834 9.88632 32.8834 9.24562V9.04997H33.911C34.5943 9.04997 34.9826 8.67919 34.9826 8.06914C34.9826 7.37744 34.4938 7.08179 33.8111 7.08179C32.9775 7.08179 32.3447 7.62249 32.3447 8.55988V9.24562C32.3447 10.2264 32.9775 10.6215 33.8111 10.6215C34.2 10.6215 34.6447 10.471 34.7881 10.4022V9.91101H34.7387C34.5942 9.98093 34.2 10.1325 33.8111 10.1325ZM32.8834 8.55988C32.8834 7.86809 33.2218 7.57253 33.8111 7.57253C34.2 7.57253 34.4503 7.69836 34.4503 8.06914C34.4503 8.40936 34.2999 8.6034 33.7611 8.6034H32.8834V8.55988Z"
        fill="white"
      />
      <path
        d="M35.7046 10.5718H36.2434V8.35861L36.6312 7.96834C36.7886 7.81668 37.0266 7.7233 37.271 7.7233H37.5153V7.13208H37.2962C36.8514 7.13208 36.5507 7.42111 36.2934 7.81668L36.2435 7.89303V7.13208H35.7047V10.5718H35.7046Z"
        fill="white"
      />
      <path
        d="M38.2007 10.5721H38.7394V5.85596H37.6113V6.3467H38.2007V10.5721Z"
        fill="white"
      />
      <path d="M40.609 5.85596H40.0708V6.44718H40.609V5.85596Z" fill="white" />
      <path
        d="M40.0711 10.5722H40.6094V7.13257H39.4878V7.62265H40.0711V10.5722Z"
        fill="white"
      />
      <path
        d="M42.4093 5.85596H41.8711V6.44718H42.4093V5.85596Z"
        fill="white"
      />
      <path
        d="M40.7925 11.7546H40.9428C41.9709 11.7546 42.4092 11.257 42.4092 10.1756V7.13257H41.2813V7.62265H41.871V10.2766C41.871 10.9177 41.6766 11.2569 41.0375 11.2569H40.7925V11.7546Z"
        fill="white"
      />
      <path
        d="M43.3936 10.5721H43.9317V8.95009H44.2702L45.4487 10.5721H46.0631V10.5221L44.7154 8.67922L46.0126 7.18296V7.13244H45.3982L44.2702 8.45887H43.9317V5.85596H43.3936V10.5721Z"
        fill="white"
      />
      <path
        d="M47.7249 10.1325C47.1851 10.1325 46.7968 9.88632 46.7968 9.24562V9.04997H47.8248C48.508 9.04997 48.8964 8.67919 48.8964 8.06914C48.8964 7.37744 48.4076 7.08179 47.7249 7.08179C46.8907 7.08179 46.2573 7.62249 46.2573 8.55988V9.24562C46.2573 10.2264 46.8906 10.6215 47.7249 10.6215C48.1132 10.6215 48.5585 10.471 48.7019 10.4022V9.91101H48.652C48.5079 9.98093 48.1132 10.1325 47.7249 10.1325ZM46.7967 8.55988C46.7967 7.86809 47.1356 7.57253 47.7248 7.57253C48.1131 7.57253 48.3629 7.69836 48.3629 8.06914C48.3629 8.40936 48.213 8.6034 47.6744 8.6034H46.7967V8.55988Z"
        fill="white"
      />
      <path
        d="M8.10596 12.8837V12.8337H9.28987C9.51009 13.9672 10.0258 15.8822 10.3222 16.6002C10.6177 15.8822 11.1844 13.9673 11.4046 12.8337H12.4869V12.8837C12.0658 14.7986 11.3541 16.7701 11.0076 17.5574H9.58535C9.23938 16.77 8.50242 14.7986 8.10596 12.8837Z"
        fill="white"
      />
      <path
        d="M12.4868 16.2025V15.5415C12.4868 14.5525 13.2485 14.0613 14.2304 14.0613C15.093 14.0613 15.7853 14.3321 15.7853 15.1953C15.7853 15.9315 15.2445 16.2025 14.501 16.2025H13.5696V16.2283C13.5696 16.5996 13.9413 16.669 14.3066 16.669C14.6772 16.669 15.0677 16.6249 15.4389 16.5239H15.4894V17.4118C15.0929 17.5569 14.5268 17.6074 14.2121 17.6074C13.198 17.6074 12.4868 17.2107 12.4868 16.2025ZM14.4324 15.5666C14.6526 15.5666 14.7976 15.4908 14.7976 15.2705C14.7976 14.9749 14.5269 14.9492 14.2304 14.9492C13.8151 14.9492 13.5697 15.0943 13.5697 15.5162V15.5667H14.4324V15.5666Z"
        fill="white"
      />
      <path
        d="M16.2393 14.1118H17.3221V14.5337C17.5176 14.2375 17.8889 14.0613 18.2353 14.0613H18.506V14.9996H18.1343C17.7625 14.9996 17.4919 15.1448 17.3221 15.3398V17.5568H16.2393V14.1118Z"
        fill="white"
      />
      <path
        d="M19.0522 16.9143C19.6436 16.329 20.2608 15.6362 20.6512 14.9999H19.1022V14.1121H21.9538V14.7544C21.6579 15.3402 21.0224 16.1781 20.531 16.6693H22.0043V17.5572H19.0522V16.9143Z"
        fill="white"
      />
      <path
        d="M22.5391 16.2025V15.5415C22.5391 14.5525 23.3008 14.0613 24.2826 14.0613C25.1454 14.0613 25.8382 14.3321 25.8382 15.1953C25.8382 15.9315 25.2967 16.2025 24.5534 16.2025H23.622V16.2283C23.622 16.5996 23.9937 16.669 24.3589 16.669C24.7295 16.669 25.1206 16.6249 25.4912 16.5239H25.5417V17.4118C25.1453 17.5569 24.5792 17.6074 24.2644 17.6074C23.2503 17.6074 22.5391 17.2107 22.5391 16.2025ZM24.4846 15.5666C24.7048 15.5666 24.8499 15.4908 24.8499 15.2705C24.8499 14.9749 24.5792 14.9492 24.2826 14.9492C23.8679 14.9492 23.622 15.0943 23.622 15.5162V15.5667H24.4846V15.5666Z"
        fill="white"
      />
      <path
        d="M26.2578 12.8335H27.3407V15.296H27.5862L28.5681 14.1121H29.7514V14.1626L28.4735 15.6609L29.7514 17.5066V17.5571H28.524L27.5862 16.178H27.3407V17.5571H26.2578V12.8335Z"
        fill="white"
      />
      <path
        d="M30.0083 16.2025V15.5415C30.0083 14.5525 30.7699 14.0613 31.7518 14.0613C32.6145 14.0613 33.3068 14.3321 33.3068 15.1953C33.3068 15.9315 32.7654 16.2025 32.0225 16.2025H31.091V16.2283C31.091 16.5996 31.4622 16.669 31.8275 16.669C32.1986 16.669 32.5892 16.6249 32.9603 16.5239H33.0108V17.4118C32.6144 17.5569 32.0477 17.6074 31.733 17.6074C30.7194 17.6074 30.0083 17.2107 30.0083 16.2025ZM31.9532 15.5666C32.1735 15.5666 32.3184 15.4908 32.3184 15.2705C32.3184 14.9749 32.0477 14.9492 31.7517 14.9492C31.3365 14.9492 31.091 15.0943 31.091 15.5162V15.5667H31.9532V15.5666Z"
        fill="white"
      />
      <path
        d="M33.8638 14.1118H34.9466V14.5337C35.1416 14.2375 35.5127 14.0613 35.8592 14.0613H36.1299V14.9996H35.7583C35.387 14.9996 35.1163 15.1448 34.9466 15.3398V17.5568H33.8638V14.1118Z"
        fill="white"
      />
      <path
        d="M37.2199 14.9999H36.729V14.1121H38.3023V17.5572H37.2199V14.9999ZM37.2199 12.8335H38.3023V13.7219H37.2199V12.8335Z"
        fill="white"
      />
      <path
        d="M38.9791 14.1118H40.0619V14.6342L40.2064 14.5337C40.6028 14.2504 40.8987 14.0613 41.3397 14.0613C42.0069 14.0613 42.3216 14.4831 42.3216 15.1448V17.5568H41.2452V15.4403C41.2452 15.1694 41.1947 14.9995 40.924 14.9995C40.7225 14.9995 40.477 15.1511 40.2569 15.2957C40.2569 15.2957 40.0618 15.4091 40.0618 15.4156V17.5568H38.979V14.1118H38.9791Z"
        fill="white"
      />
      <path
        d="M43.3888 17.8532H44.1757C44.8868 17.8532 45.2579 17.7021 45.2579 16.9908V16.9714L45.0125 17.0913C44.7482 17.217 44.471 17.3616 44.0999 17.3616C43.3635 17.3616 42.9482 16.965 42.9482 16.2287V15.7873C42.9482 14.7544 43.7346 14.1121 44.7669 14.1121H46.3409V17.0659C46.3409 18.1235 45.6231 18.7411 44.5719 18.7411H43.3887V17.8532H43.3888ZM45.0883 16.2533L45.258 16.1845V14.9999H44.8617C44.3201 14.9999 44.0307 15.2456 44.0307 15.7872V16.0328C44.0307 16.3038 44.1506 16.423 44.4212 16.423C44.6413 16.4231 44.8993 16.3351 45.0883 16.2533Z"
        fill="white"
      />
      <path
        d="M46.9458 17.4816V16.5743H46.9963C47.361 16.6436 47.758 16.6937 48.1039 16.6937C48.2741 16.6937 48.7146 16.6937 48.7146 16.4985C48.7146 16.354 48.6141 16.3163 48.4439 16.2782L47.9025 16.1519C47.2353 16.0015 46.9458 15.636 46.9458 15.1694C46.9458 14.3826 47.7075 14.0613 48.6706 14.0613C49.0105 14.0613 49.407 14.1118 49.6524 14.1623V15.069H49.6019C49.3065 15.0249 48.9601 14.9749 48.6454 14.9749C48.4692 14.9749 48.0787 14.9749 48.0787 15.1448C48.0787 15.2958 48.2555 15.3274 48.4188 15.3651L48.891 15.4661C49.3694 15.5666 49.8475 15.8122 49.8475 16.4733C49.8475 17.387 49.0105 17.6074 48.104 17.6074C47.7075 17.6074 47.2671 17.5568 46.9458 17.4816Z"
        fill="white"
      />
      <path
        d="M50.3413 14.9999V14.1121H51.4241V14.9999C51.4241 15.7872 51.5938 16.4735 51.8898 16.8203C52.1859 16.4735 52.362 15.7872 52.362 14.9999V14.1121H53.4384V14.9999C53.4384 15.7872 53.6147 16.4735 53.9105 16.8203C54.2066 16.4735 54.3762 15.7872 54.3762 14.9999V14.1121H55.4591V14.9999C55.4591 16.1781 54.8168 17.261 54.4766 17.5571H53.3439C53.2306 17.4625 52.9728 17.0153 52.8783 16.7197C52.7772 17.0153 52.4818 17.4502 52.362 17.5571H51.2293C50.8827 17.2611 50.3413 16.1781 50.3413 14.9999Z"
        fill="white"
      />
      <path
        d="M56.4811 14.9999H55.9897V14.1121H57.5635V17.5572H56.4812V14.9999H56.4811ZM56.4811 12.8335H57.5634V13.7219H56.4811V12.8335Z"
        fill="white"
      />
      <path
        d="M58.1436 17.8531H58.2951C58.7355 17.8531 58.8865 17.702 58.8865 17.261V14.9999H58.3897V14.1121H59.963V17.3615C59.963 18.2815 59.3522 18.741 58.5911 18.741H58.1436V17.8531H58.1436ZM58.8865 12.8335H59.963V13.7219H58.8865V12.8335Z"
        fill="white"
      />
      <path
        d="M60.5665 16.9143C61.1584 16.329 61.7751 15.6362 62.1656 14.9999H60.617V14.1121H63.4686V14.7544C63.1726 15.3402 62.5367 16.1781 62.0457 16.6693H63.5186V17.5572H60.5664V16.9143H60.5665Z"
        fill="white"
      />
      <path
        d="M63.9619 16.2025V15.5415C63.9619 14.5525 64.7236 14.0613 65.7055 14.0613C66.5681 14.0613 67.2605 14.3321 67.2605 15.1953C67.2605 15.9315 66.7189 16.2025 65.9762 16.2025H65.0447V16.2283C65.0447 16.5996 65.4159 16.669 65.7812 16.669C66.1523 16.669 66.5429 16.6249 66.9139 16.5239H66.9644V17.4118C66.568 17.5569 66.0013 17.6074 65.6866 17.6074C64.6732 17.6074 63.9619 17.2107 63.9619 16.2025ZM65.9071 15.5666C66.1272 15.5666 66.2723 15.4908 66.2723 15.2705C66.2723 14.9749 66.0015 14.9492 65.7056 14.9492C65.2903 14.9492 65.0449 15.0943 65.0449 15.5162V15.5667H65.9071V15.5666Z"
        fill="white"
      />
      <path
        d="M67.8647 14.1118H68.9477V14.5337C69.1426 14.2375 69.5137 14.0613 69.8602 14.0613H70.1308V14.9996H69.7592C69.388 14.9996 69.1173 15.1448 68.9476 15.3398V17.5568H67.8647V14.1118Z"
        fill="white"
      />
    </Svg>
  );
};
